import { api } from "@/lib/api";

export const adminProvidersApi = {
    list: (params = {}) => api.get("/admin/providers", { params }).then((r) => r.data),
    get: (id) => api.get(`/admin/providers/${id}`).then((r) => r.data),
    create: (payload) => api.post("/admin/providers", payload).then((r) => r.data),
    update: (id, payload) => api.patch(`/admin/providers/${id}`, payload).then((r) => r.data),
    delete: (id) => api.delete(`/admin/providers/${id}`).then((r) => r.data),

    listLocations: (pid) =>
        api.get(`/admin/providers/${pid}/locations`).then((r) => r.data.items),
    createLocation: (pid, payload) =>
        api.post(`/admin/providers/${pid}/locations`, payload).then((r) => r.data),
    updateLocation: (pid, locId, payload) =>
        api.patch(`/admin/providers/${pid}/locations/${locId}`, payload).then((r) => r.data),
    deleteLocation: (pid, locId) =>
        api.delete(`/admin/providers/${pid}/locations/${locId}`).then((r) => r.data),

    listStaff: (pid) =>
        api.get(`/admin/providers/${pid}/staff`).then((r) => r.data.items),
    createStaff: (pid, payload) =>
        api.post(`/admin/providers/${pid}/staff`, payload).then((r) => r.data),
    updateStaff: (pid, staffId, payload) =>
        api.patch(`/admin/providers/${pid}/staff/${staffId}`, payload).then((r) => r.data),
    deleteStaff: (pid, staffId) =>
        api.delete(`/admin/providers/${pid}/staff/${staffId}`).then((r) => r.data),
};
